import { ErrorHandler } from '@angular/core';
import { environment } from '../environments/environment';
import * as Sentry from 'raven-js';

if (environment.sentry.enabled) {
  Sentry.config(environment.sentry.dsn, { release: environment.version }).install();
}

export class AppErrorHandler implements ErrorHandler {
  handleError(err: Error) {
    if (environment.sentry.enabled) {
      Sentry.captureException(err, {
        extra: {
          // get the current cookies
          cookies: document.cookie.split(';').reduce((acc, cookie) => {
            const [key, value] = cookie.split('=');
            acc[key.trim()] = value;

            return acc;
          }, {})
        }
      });
    } else {
      console.error(err);
    }
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/app.error-handler.ts